import { Injectable } from '@angular/core';

import { ColumnLayoutService } from 'packages/sports/web/app/src/layout/column-layout.service';

import { AccaBoostLayout, AccaBoostLayoutProvider } from '../../model';

@Injectable()
export class AccaBoostLayoutService implements AccaBoostLayoutProvider {
    constructor(private columnLayout: ColumnLayoutService) {}

    getLayout(): AccaBoostLayout {
        return this.columnLayout.layout.isRightVisible ? AccaBoostLayout.Desktop : AccaBoostLayout.Mobile;
    }

    get isDesktop(): boolean {
        return this.getLayout() === AccaBoostLayout.Desktop;
    }
}
